<div class="flex flex-col content-holder">
  <ng-container *ngIf="step === 'init'">
    <div class="content-title">
      {{ "common-messages.start-email" | translate }}
    </div>
    <form (ngSubmit)="sendOtp()" class="flex flex-col gap-24x">
      <ui-input
        #emailField
        [(ngModel)]="email"
        (ngModelChange)="onEmailModelChange()"
        [placeholder]="'common-keywords.type-here' | translate"
        [ngModelOptions]="{ standalone: true }"
        class="content-control email-input-fit"
        type="email"
        size="large"
      ></ui-input>
      <ui-button
        [isDisabled]="isDisableInit || !!(loading$ | async)"
        [loading]="!!(loading$ | async)"
        (btnClick)="sendOtp()"
        class="content-button"
        size="large"
        type="black"
      >
        {{ "common-keywords.get-started" | translate }}
        <!--        <span>-->
        <!--          <svg-->
        <!--            width="10"-->
        <!--            height="10"-->
        <!--            viewBox="0 0 10 10"-->
        <!--            fill="none"-->
        <!--            xmlns="http://www.w3.org/2000/svg"-->
        <!--          >-->
        <!--            <path-->
        <!--              d="M9.6875 0.833333C9.6875 0.545685 9.45431 0.3125 9.16667 0.3125C8.87902 0.3125 8.64583 0.545685 8.64583 0.833333V1.5625C8.64583 2.44618 8.64543 3.07761 8.60499 3.57258C8.56504 4.06147 8.48865 4.37119 8.362 4.61977C8.11233 5.10977 7.71394 5.50816 7.22393 5.75783C6.97536 5.88449 6.66564 5.96088 6.17675 6.00082C5.68178 6.04126 5.05034 6.04167 4.16667 6.04167H2.09074L3.80578 4.32662C4.00918 4.12322 4.00918 3.79345 3.80578 3.59005C3.60239 3.38665 3.27261 3.38665 3.06922 3.59005L0.465049 6.19422C0.26165 6.39761 0.26165 6.72739 0.465049 6.93078L3.06922 9.53495C3.27261 9.73835 3.60239 9.73835 3.80578 9.53495C4.00918 9.33155 4.00918 9.00178 3.80578 8.79838L2.09074 7.08333H4.18978C5.04528 7.08334 5.71922 7.08334 6.26157 7.03903C6.81488 6.99382 7.27694 6.89991 7.69684 6.68596C8.38285 6.33642 8.94059 5.77868 9.29013 5.09267C9.50408 4.67278 9.59799 4.21072 9.64319 3.65741C9.68751 3.11506 9.6875 2.44113 9.6875 1.58564V0.833333Z"-->
        <!--            />-->
        <!--          </svg>-->
        <!--        </span>-->
      </ui-button>
    </form>
    <div class="content-extra-description">
      {{ "common-messages.have-account" | translate }}
      <a [routerLink]="'/auth'">
        {{ "common-keywords.login" | translate }}
      </a>
    </div>
  </ng-container>
  <ng-container *ngIf="step === 'verify'">
    <div class="content-title">
      {{
        "auth.component.register-verification.enter-verification-code"
          | translate
      }}
      <label
        [innerHTML]="
          'auth.component.register-verification.sent-code-to-mail'
            | translate: { email: email }
        "
      ></label>
    </div>
    <form (ngSubmit)="verifyOtp()" class="flex flex-col gap-24x">
      <ui-input
        [(ngModel)]="otp"
        (ngModelChange)="otp = $event.toUpperCase()"
        [otpLength]="5"
        (inputKeyDown)="$event.key === 'Enter' && verifyOtp()"
        [ngModelOptions]="{ standalone: true }"
        class="content-control otp-input"
        type="otp"
        size="large"
      ></ui-input>
      <ui-button
        [isDisabled]="isDisableVerify || !!(loading$ | async)"
        [loading]="!!(loading$ | async)"
        (btnClick)="verifyOtp()"
        class="content-button"
        size="large"
        type="black"
      >
        {{ "common-keywords.submit" | translate }}
        <!--        <span>-->
        <!--          <svg-->
        <!--            width="10"-->
        <!--            height="10"-->
        <!--            viewBox="0 0 10 10"-->
        <!--            fill="none"-->
        <!--            xmlns="http://www.w3.org/2000/svg"-->
        <!--          >-->
        <!--            <path-->
        <!--              d="M9.6875 0.833333C9.6875 0.545685 9.45431 0.3125 9.16667 0.3125C8.87902 0.3125 8.64583 0.545685 8.64583 0.833333V1.5625C8.64583 2.44618 8.64543 3.07761 8.60499 3.57258C8.56504 4.06147 8.48865 4.37119 8.362 4.61977C8.11233 5.10977 7.71394 5.50816 7.22393 5.75783C6.97536 5.88449 6.66564 5.96088 6.17675 6.00082C5.68178 6.04126 5.05034 6.04167 4.16667 6.04167H2.09074L3.80578 4.32662C4.00918 4.12322 4.00918 3.79345 3.80578 3.59005C3.60239 3.38665 3.27261 3.38665 3.06922 3.59005L0.465049 6.19422C0.26165 6.39761 0.26165 6.72739 0.465049 6.93078L3.06922 9.53495C3.27261 9.73835 3.60239 9.73835 3.80578 9.53495C4.00918 9.33155 4.00918 9.00178 3.80578 8.79838L2.09074 7.08333H4.18978C5.04528 7.08334 5.71922 7.08334 6.26157 7.03903C6.81488 6.99382 7.27694 6.89991 7.69684 6.68596C8.38285 6.33642 8.94059 5.77868 9.29013 5.09267C9.50408 4.67278 9.59799 4.21072 9.64319 3.65741C9.68751 3.11506 9.6875 2.44113 9.6875 1.58564V0.833333Z"-->
        <!--            />-->
        <!--          </svg>-->
        <!--        </span>-->
      </ui-button>
    </form>
    <div class="content-extra-description">
      {{
        "auth.component.register-verification.ask-not-received-code" | translate
      }}
      <ng-container *ngIf="!(loading$ | async)">
        <span
          *ngIf="seconds > 0"
          [innerHTML]="
            'auth.component.register-verification.resend-in-sec'
              | translate: { value: seconds }
          "
        >
        </span>
        <a
          class="cursor-pointer"
          *ngIf="seconds <= 0"
          disabled=""
          (click)="sendOtp(true)"
        >
          {{ "common-keywords.resend" | translate }}
        </a>
      </ng-container>
    </div>
  </ng-container>
</div>
